import '../styles.scss';

export const Loader = () => (
    <div className="ldsHourglass"></div>
);
